module.exports = __webpack_public_path__ + "img/rob_helm.e31f74cb.jpg";